<template>
  <el-dialog
    title="诚信廉洁承诺"
    :visible.sync="showDialog"
    width="70rem"
    :close-on-click-modal="false"
    :append-to-body="true"
    :before-close="closeDialog"
  >
    <p>为维护市场公平竞争，营造诚实守信的招投标/采购交易环境，我单位自愿 加入“精彩纵横云采购平台企业会员信息库”（以下简称会员库），自愿将本单位相关信息予以登记并在精彩纵横云采购平台网站对外发布，会员库发布的相关信息均经我单位确认无误，对此郑重承诺如下：</p>
    <p>一、我单位提交并在会员库发布的相关信息均真实有效，提交的材料无任何伪造、修改、虚假成份，材料所述内容均为本单位真实拥有。若违反本承诺一经查实，本单位愿意接受公开通报，自愿退出所有精彩纵横云采购平台正在进行的投标项目并取消会员资格，按照《中华人民共和国招标投标法》第五十四条，禁止三年内进入招标采购市场。</p>
    <p>二、我单位在参加精彩纵横云采购平台项目投标/采购过程中严格遵守各项廉政制度，如有违反自愿按规定接受处罚。</p>
    <p>三、我单位今后将认真、及时维护和更新会员库中与我单位有关的内容，如未能及时维护和更新，将自愿承担由此造成的一切不良后果。</p>
  </el-dialog>
</template>

<script>
export default {
  name: 'GoodFaithBook',

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    closeDialog() {
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  text-indent: 2em;
  text-align: left;
  margin: 0;
  line-height: 1.8;
}
</style>